// extracted by mini-css-extract-plugin
module.exports = {"DrillingTable":"DrillingTable_DrillingTable__51ZQV"};